"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Title = _interopRequireDefault(require("@airasia/phoenix-components/components/Title"));

var _constant = require("@airasia/phoenix-components/components/Title/constant");

var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _ShimmerCarousel = _interopRequireDefault(require("@airasia/phoenix-components/components/ShimmerCarousel"));

var _constant2 = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _cardTimer = require("../CardTimer/cardTimer.util");

var _constant3 = require("../CardTimer/constant");

var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));

var _Modal = _interopRequireDefault(require("@airasia/phoenix-components/components/Modal"));

var _CarouselSlider = _interopRequireDefault(require("../CarouselSlider"));

var _constant4 = require("./constant");

var _Carousel = _interopRequireDefault(require("./Carousel.proptypes"));

var _constant5 = require("../Card/constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable react/prop-types */


var CarouselContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__CarouselContainer",
  componentId: "sc-bjf82e-0"
})(["display:flex;flex-direction:column;justify-content:flex-start;outline:none !important;height:100%;"]);

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Carousel__Wrapper",
  componentId: "sc-bjf82e-1"
})(["margin-inline:auto;box-shadow:0 4px 8px 0 rgba(0,0,0,0.2);border-radius:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.space.micro;
}, function (_ref2) {
  var isMobile = _ref2.isMobile,
      theme = _ref2.theme;
  return !isMobile ? "\n        padding: ".concat(theme.space.small, " ").concat(theme.space.standard, ";\n        width: 808px;\n      ") : "padding-left: ".concat(theme.space.small);
});

var HorizontalDivider = _styledComponents.default.hr.withConfig({
  displayName: "Carousel__HorizontalDivider",
  componentId: "sc-bjf82e-2"
})(["border:none;border-bottom:1px solid ", ";width:", ";margin-left:", ";margin-top:", ";margin-bottom:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.backgroundColor.greyLight;
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? '104%' : '106%';
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? '-15px' : '-24px';
}, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.none);
}, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.space.XSmall);
});

var ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__ModalContainer",
  componentId: "sc-bjf82e-3"
})(function (_ref8) {
  var theme = _ref8.theme,
      isMobile = _ref8.isMobile;
  return "\n    #airasia-phoenix-modal-close-button {\n      top: ".concat(theme.space.normal, ";\n    }\n    #airasia-phoenix-modal-content {\n      padding: ").concat(theme.space.none, ";\n      overflow: unset;\n      height: 900px;\n    }\n    ").concat(isMobile ? "\n      #userguide-modal {\n        top: 20%;\n        position: absolute !important;\n        margin-left: 20px;\n        margin-right: 20px;\n      }\n    " : '', "\n  ");
});

var TitleContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__TitleContainer",
  componentId: "sc-bjf82e-4"
})(["margin:", ";@media screen and (max-width:", "){margin:", ";}text-align:", ";"], function (_ref9) {
  var titleMargin = _ref9.titleMargin,
      theme = _ref9.theme;
  return titleMargin || "0px ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.tiny);
}, _constant2.BREAKPOINTS.MOBILE, function (_ref10) {
  var theme = _ref10.theme;
  return "0px ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.small);
}, function (_ref11) {
  var titleAlign = _ref11.titleAlign;
  return titleAlign || 'left';
});

TitleContainer.displayName = 'TitleContainer';

var TitleContainerCrossSell = _styledComponents.default.div.withConfig({
  displayName: "Carousel__TitleContainerCrossSell",
  componentId: "sc-bjf82e-5"
})(["margin:", ";text-align:", ";display:flex;align-items:center;"], function (_ref12) {
  var titleMargin = _ref12.titleMargin,
      theme = _ref12.theme;
  return titleMargin || "0px ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.XXXSmall);
}, function (_ref13) {
  var titleAlign = _ref13.titleAlign;
  return titleAlign || 'left';
});

TitleContainerCrossSell.displayName = 'TitleContainerCrossSell';

var SubHeadlineContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__SubHeadlineContainer",
  componentId: "sc-bjf82e-6"
})(["display:flex;", ";margin-top:0px;"], function (_ref14) {
  var titleAlign = _ref14.titleAlign;
  return titleAlign === 'center' && 'justify-content: center';
});

var TitleContainerForMob = _styledComponents.default.div.withConfig({
  displayName: "Carousel__TitleContainerForMob",
  componentId: "sc-bjf82e-7"
})(["display:flex;align-items:center;justify-content:space-between;text-align:", ";"], function (_ref15) {
  var titleAlign = _ref15.titleAlign;
  return titleAlign || 'left';
});

var LinkContainerForMob = _styledComponents.default.div.withConfig({
  displayName: "Carousel__LinkContainerForMob",
  componentId: "sc-bjf82e-8"
})(["text-overflow:ellipsis;white-space:nowrap;overflow:hidden;flex:1;"]);

var ShowMoreTextContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__ShowMoreTextContainer",
  componentId: "sc-bjf82e-9"
})(["float:right;padding:5px;"]);

var ValidDateWrapper = _styledComponents.default.div.withConfig({
  displayName: "Carousel__ValidDateWrapper",
  componentId: "sc-bjf82e-10"
})(["display:flex;align-items:center;display:flex;height:", ";padding:", ";border-radius:", ";background:", ";gap:", ";color:", ";text-align:center;font-family:", ";font-size:", ";font-style:normal;font-weight:", ";line-height:150%;"], function (_ref16) {
  var theme = _ref16.theme;
  return "".concat(theme.space.normal);
}, function (_ref17) {
  var theme = _ref17.theme;
  return "".concat(theme.space.nano, " ").concat(theme.space.micro);
}, function (_ref18) {
  var theme = _ref18.theme;
  return "".concat(theme.space.micro);
}, function (_ref19) {
  var theme = _ref19.theme;
  return "".concat(theme.colors.oldLace);
}, function (_ref20) {
  var theme = _ref20.theme;
  return "".concat(theme.space.micro);
}, function (_ref21) {
  var theme = _ref21.theme;
  return "".concat(theme.colors.tertiaryYellow);
}, function (_ref22) {
  var theme = _ref22.theme;
  return "".concat(theme.fontFamily.default);
}, function (_ref23) {
  var theme = _ref23.theme;
  return "".concat(theme.fontSize.XSmall);
}, function (_ref24) {
  var theme = _ref24.theme;
  return "".concat(theme.fontWeight.medium);
});

ValidDateWrapper.displayName = 'ValidDateWrapper';
var StyledTitleComponent = (0, _styledComponents.default)(_Title.default).withConfig({
  displayName: "Carousel__StyledTitleComponent",
  componentId: "sc-bjf82e-11"
})(function (_ref25) {
  var theme = _ref25.theme,
      styledAs = _ref25.styledAs,
      headlineFontSize = _ref25.headlineFontSize,
      headlineFontWeight = _ref25.headlineFontWeight,
      headlineLineHeight = _ref25.headlineLineHeight,
      titleAlign = _ref25.titleAlign,
      color = _ref25.color,
      headlineLineMarginRight = _ref25.headlineLineMarginRight;
  return "\n\n  ".concat(styledAs === _constant.TITLE_TYPES.H2 ? "\n        font-size: ".concat(theme.fontSize.titleNormal, ";\n        font-weight: ").concat(theme.fontWeight.medium, ";\n        line-height: ").concat(theme.lineHeight.titleNormal, ";\n        text-align: ").concat(titleAlign || 'left', ";  \n      ") : "", "\n\n  ").concat(styledAs === _constant.TITLE_TYPES.H3 ? "\n        font-size: ".concat(theme.fontSize.titleSmall, ";\n        font-weight: ").concat(theme.fontWeight.medium, ";\n        line-height: ").concat(theme.lineHeight.titleSmall, ";\n        text-align: ").concat(titleAlign || 'left', ";\n      ") : "", "\n\n  ").concat(styledAs === _constant.TITLE_TYPES.FREE_STYLE ? "\n        font-size: ".concat(headlineFontSize || theme.lineHeight.titleNormal, ";\n        font-weight: ").concat(headlineFontWeight || theme.fontWeight.medium, ";\n        line-height: ").concat(headlineLineHeight || theme.lineHeight.titleNormal, ";\n        text-align: ").concat(titleAlign || 'left', ";\n        margin-right:  ").concat(headlineLineMarginRight, ";\n        color:  ").concat(color, "\n      ") : "", "\n    \n  ");
});

var ButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__ButtonContainer",
  componentId: "sc-bjf82e-12"
})(["width:auto;text-align:center;overflow-wrap:break-word;margin-top:", ";@media screen and (max-width:", "){margin-left:", ";margin-right:", ";margin-bottom:", ";}"], function (_ref26) {
  var buttonMargin = _ref26.buttonMargin,
      theme = _ref26.theme;
  return buttonMargin || "".concat(theme.space.semiLarge);
}, _constant2.BREAKPOINTS.MOBILE, function (_ref27) {
  var theme = _ref27.theme;
  return "".concat(theme.space.small);
}, function (_ref28) {
  var theme = _ref28.theme;
  return "".concat(theme.space.small);
}, function (_ref29) {
  var isMobile = _ref29.isMobile,
      theme = _ref29.theme;
  return isMobile && "".concat(theme.space.small);
});

var Carousel = function Carousel(props) {
  var _useState = (0, _react.useState)(typeof window !== 'undefined' && window.innerWidth < 600),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  var indexNumber = props.indexNumber,
      gtmConsumerName = props.gtmConsumerName,
      heading = props.heading,
      data = props.data,
      viewPort = props.viewPort,
      theme = props.theme,
      isLoading = props.isLoading,
      templateType = props.templateType,
      queryParams = props.queryParams,
      fireGtm = props.fireGtm,
      cardConfig = props.cardConfig,
      accessible = props.accessible,
      customProperties = props.customProperties,
      isIE = props.isIE,
      showFormattedPrice = props.showFormattedPrice,
      allowLocaleFormat = props.allowLocaleFormat,
      locale = props.locale,
      localeConfig = props.localeConfig,
      carouselWidgetOrder = props.carouselWidgetOrder,
      isHideFooter = props.isHideFooter,
      environment = props.environment,
      enableProgressiveImageLoading = props.enableProgressiveImageLoading,
      lazyLoadImage = props.lazyLoadImage,
      gaID = props.gaID,
      timerTimeZone = props.timerTimeZone,
      showCarouselInPopup = props.showCarouselInPopup;

  var _ref30 = heading || {},
      titleAlign = _ref30.titleAlign,
      titleMargin = _ref30.titleMargin,
      widgetWidth = _ref30.widgetWidth,
      headline = _ref30.headline,
      headlineStyle = _ref30.headlineStyle,
      headlineFontSize = _ref30.headlineFontSize,
      headlineFontWeight = _ref30.headlineFontWeight,
      headlineLineHeight = _ref30.headlineLineHeight,
      subHeadline = _ref30.subHeadline,
      subHeadlineFontSize = _ref30.subHeadlineFontSize,
      subHeadlineFontWeight = _ref30.subHeadlineFontWeight,
      subHeadlineFontColor = _ref30.subHeadlineFontColor,
      showMoreURL = _ref30.showMoreURL,
      widgetID = _ref30.widgetID,
      widgetName = _ref30.widgetName,
      gtmParameters = _ref30.gtmParameters,
      minCardsThreeColumn = _ref30.minCardsThreeColumn,
      showMoreText = _ref30.showMoreText,
      showMoreTextTarget = _ref30.showMoreTextTarget,
      decimalType = _ref30.decimalType,
      showMoreCallBack = _ref30.showMoreCallBack,
      showMoreType = _ref30.showMoreType,
      customCardHeaderHeight = _ref30.customCardHeaderHeight,
      hideBorder = _ref30.hideBorder,
      button = _ref30.button,
      buttonUrl = _ref30.buttonUrl,
      buttonMargin = _ref30.buttonMargin,
      isHolidaysCard = _ref30.isHolidaysCard,
      removeIndentation = _ref30.removeIndentation,
      removeSlider = _ref30.removeSlider,
      loadMoreLabel = _ref30.loadMoreLabel,
      maxCards = _ref30.maxCards;

  var headlineType = heading && heading.headlineType || 'h1';

  var _ref31 = gtmParameters || {},
      event = _ref31.event,
      eventActionClick = _ref31.eventActionClick,
      eventActionView = _ref31.eventActionView;

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      hiddenCard = _useState4[0],
      setHiddenCard = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      hideHeader = _useState6[0],
      setHideHeader = _useState6[1];

  var _ref32 = gtmParameters || {},
      eventCategory = _ref32.eventCategory,
      eventLabelView = _ref32.eventLabelView,
      eventLabelCardClick = _ref32.eventLabelCardClick,
      eventLabelHeadlineClick = _ref32.eventLabelHeadlineClick,
      eventSecondaryHeadlineClick = _ref32.eventSecondaryHeadlineClick;

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      allowAccessibility = _useState8[0],
      setAllowAccessibility = _useState8[1];

  var carouseContainerRef = (0, _react.useRef)(null);
  var headlineRef = (0, _react.useRef)(null);
  var subHeadlineRef = (0, _react.useRef)(null);
  var secondaryLinkRef = (0, _react.useRef)(null);

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      openModal = _useState10[0],
      setOpenModal = _useState10[1];

  var structureGtmData = function structureGtmData() {
    var totalNumberOfCard = data && Object.keys(data).length;
    eventLabelHeadlineClick = eventLabelHeadlineClick ? eventLabelHeadlineClick.replace('{{headline}}', headline || null) : null;
    eventSecondaryHeadlineClick = eventSecondaryHeadlineClick ? eventSecondaryHeadlineClick.replace('{{secondaryHeadline}}', secondaryLinkRef || null) : null;
    eventLabelCardClick = eventLabelCardClick ? eventLabelCardClick.replace('{{widgetorder}}', indexNumber || null).replace('{{carroouselwidgetorder}}', carouselWidgetOrder || null) : null;

    if (templateType !== _constant5.TEMPLATE_TYPE.HOTELS_CROSS_SELL_CARD) {
      eventLabelView = eventLabelView.replace('{{carroouselwidgetorder}}', carouselWidgetOrder || null).replace('{{widgetorder}}', indexNumber || null).replace('{{totalNumberOfCards}}', totalNumberOfCard);
    }

    eventCategory = eventCategory ? eventCategory.replace('{{consumername}}', gtmConsumerName || null) : null;
  };

  var updateMedia = function updateMedia() {
    if (typeof window !== 'undefined') setIsMobile(window.innerWidth < 600);
  };

  (0, _react.useEffect)(function () {
    if (typeof document !== 'undefined') {
      var bodyElement = document.getElementsByTagName('body');

      if (bodyElement) {
        if (openModal) {
          bodyElement[0].style.overflow = 'hidden';
        } else {
          bodyElement[0].style.removeProperty('overflow');
        }
      }
    }
  }, [openModal]);

  var handleModalClose = function handleModalClose() {
    setOpenModal(false);
    var obj = {
      event: 'trackEventNoEcommerce',
      'eventDetails.action': 'click',
      'eventDetails.label': eventLabelView.replace('{{type}}', 'close'),
      'eventDetails.category': eventCategory
    }; // By default GTM will fire for Carousel
    // eslint-disable-next-line no-unused-expressions

    obj && fireGtm ? fireGtm(obj, 'true') : null;
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-use-before-define
      createGtmObject(); // view event

      window.addEventListener('resize', updateMedia);
    }

    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('resize', updateMedia) : null;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // const tabIndex = !accessible ? '-1' : '0';

  var createGtmObject = function createGtmObject() {
    var dataForGtm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eventLabelView;
    var click = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var obj = {
      event: event,
      'eventDetails.category': eventCategory,
      'eventDetails.action': "".concat(click ? eventActionClick : eventActionView || 'view'),
      'eventDetails.label': templateType === _constant5.TEMPLATE_TYPE.HOTELS_CROSS_SELL_CARD ? dataForGtm.replace('{{type}}', 'view') : dataForGtm
    }; // By default GTM will fire for Carousel
    // eslint-disable-next-line no-unused-expressions

    obj && fireGtm ? fireGtm(obj, 'true') : null;
  };

  var createCrossSellGtmObject = function createCrossSellGtmObject() {
    var obj = {
      event: 'trackEventNoEcommerce',
      'eventDetails.category': gtmParameters.eventCategory,
      'eventDetails.action': 'click',
      'eventDetails.label': gtmParameters.eventLabelView.replace('{{type}}', 'see_all')
    };
    fireGtm(obj, 'true');
  };

  var onClickButtonHandler = function onClickButtonHandler() {
    var obj = {
      event: 'trackEventNoEcommerce',
      'eventDetails.action': 'click',
      'eventDetails.label': gtmParameters.eventLabelView.replace('{{type}}', 'see_all'),
      'eventDetails.category': gtmParameters.eventCategory
    };
    fireGtm(obj, 'true');
    window.open(showMoreURL, '_blank');
  };

  (0, _react.useEffect)(function () {
    if (templateType === _constant5.TEMPLATE_TYPE.HOTELS_CROSS_SELL_CARD) {
      var _data$;

      var obj = {
        event: 'productImpressions',
        ecommerce: {
          currencyCode: ((_data$ = data[0]) === null || _data$ === void 0 || (_data$ = _data$.price) === null || _data$ === void 0 ? void 0 : _data$.currency) || '',
          impressions: data.map(function (item, index) {
            return {
              list: eventLabelView.replace('{{type}}', ''),
              id: item.productID,
              name: item.hotelName,
              price: item.price.value,
              brand: 'Hotel SA',
              category: 'Hotel SA - Hotel',
              variant: 'flyer-discount',
              position: index + 1,
              dimension8: '',
              dimension9: '',
              dimension10: '',
              dimension71: item.starRating.stars,
              dimension72: item.rating,
              dimension79: '1|0|0|0',
              dimension103: item.numberOfReviews,
              dimension104: item.strikeThrough.value,
              dimension110: ''
            };
          })
        }
      }; // eslint-disable-next-line no-unused-expressions

      fireGtm && fireGtm(obj, 'true');
    }
  }, [data, eventLabelView, fireGtm, templateType]);

  var renderHeadline = function renderHeadline() {
    var headlineKeyDownHandler = function headlineKeyDownHandler() {
      setAllowAccessibility(true);

      if (subHeadlineRef && subHeadlineRef.current) {
        subHeadlineRef.current.focus();
      }

      if (secondaryLinkRef && secondaryLinkRef.current) {
        secondaryLinkRef.current.focus();
      }
    };

    var headlineContainer = !isMobile ? showMoreURL && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      ref: headlineRef,
      color: _constant4.COLOR.HEADLINE_COLOR,
      href: showMoreURL,
      queryParams: queryParams,
      hoverUnderlined: false,
      size: _constant4.SIZE.HEADLINE_SIZE,
      target: "tab",
      theme: theme,
      gtmEventData: eventLabelHeadlineClick,
      fireGtm: createGtmObject,
      accessible: accessible,
      customProperties: {
        onKeyDown: function onKeyDown(e) {
          return _utilities.default.keyDownHandler(e, headlineKeyDownHandler, _constant2.KEY_CODE.ARROW_DOWN);
        },
        'aria-label': "".concat(headline, ". Actionable Left click or press down arrow to proceed"),
        role: 'application'
      },
      idConfig: {
        parentName: 'carousel',
        widgetName: _utilities.default.replacedAll(widgetName)
      }
    }, /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: headlineStyle || 'h2',
      titleAlign: titleAlign,
      headlineFontSize: headlineFontSize,
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      accessible: false
    }, headline), !showMoreText && titleAlign !== 'center' && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: _constant4.COLOR.ICON_COLOR,
      fontsize: _constant4.SIZE.ICON_SIZE,
      icon: _constant4.ICON,
      theme: theme,
      accessible: false
    })), showMoreText && /*#__PURE__*/_react.default.createElement(ShowMoreTextContainer, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      ref: secondaryLinkRef,
      color: _constant4.COLOR.SHOW_MORE_URL,
      href: showMoreURL,
      queryParams: queryParams,
      hoverUnderlined: false,
      size: _constant4.SIZE.SHOW_MORE_URL_SIZE,
      target: showMoreTextTarget,
      theme: theme,
      gtmEventData: eventSecondaryHeadlineClick,
      fireGtm: createGtmObject,
      accessible: accessible,
      callback: showMoreCallBack,
      type: showMoreType,
      customProperties: {
        onKeyDown: function onKeyDown(e) {
          return _utilities.default.keyDownHandler(e, headlineKeyDownHandler, _constant2.KEY_CODE.ARROW_DOWN);
        },
        'aria-label': "".concat(showMoreText, ". Actionable Left click or press down arrow to proceed"),
        role: 'application'
      },
      idConfig: {
        parentName: 'carousel',
        widgetName: _utilities.default.replacedAll(widgetName)
      }
    }, showMoreText))) || /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: headlineStyle || 'h2',
      titleAlign: titleAlign,
      headlineFontSize: headlineFontSize,
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight
    }, headline) : showMoreURL && /*#__PURE__*/_react.default.createElement(TitleContainerForMob, {
      titleAlign: titleAlign
    }, /*#__PURE__*/_react.default.createElement(LinkContainerForMob, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      color: _constant4.COLOR.HEADLINE_COLOR,
      href: showMoreURL,
      queryParams: queryParams,
      hoverUnderlined: false,
      size: _constant4.SIZE.HEADLINE_SIZE,
      target: "tab",
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: headlineStyle || 'h3',
      titleAlign: titleAlign,
      headlineFontSize: headlineFontSize,
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      textLimit: _constant4.SIZE.WITH_ICON_TEXT_LIMIT
    }, headline))), !showMoreText && titleAlign !== 'center' && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: _constant4.COLOR.ICON_COLOR,
      fontsize: _constant4.SIZE.ICON_SIZE,
      icon: _constant4.ICON,
      theme: theme
    }), showMoreText && /*#__PURE__*/_react.default.createElement(ShowMoreTextContainer, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      ref: secondaryLinkRef,
      color: _constant4.COLOR.SHOW_MORE_URL,
      href: showMoreURL,
      queryParams: queryParams,
      hoverUnderlined: false,
      size: _constant4.SIZE.SHOW_MORE_URL_SIZE,
      target: showMoreTextTarget,
      theme: theme,
      gtmEventData: eventSecondaryHeadlineClick,
      fireGtm: createGtmObject,
      accessible: accessible,
      customProperties: {
        onKeyDown: function onKeyDown(e) {
          return _utilities.default.keyDownHandler(e, headlineKeyDownHandler, _constant2.KEY_CODE.ARROW_DOWN);
        },
        'aria-label': "".concat(showMoreText, ". Actionable Left click or press down arrow to proceed"),
        role: 'application'
      },
      idConfig: {
        parentName: 'carousel',
        widgetName: _utilities.default.replacedAll(widgetName)
      },
      callback: showMoreCallBack,
      type: showMoreType
    }, showMoreText))) || /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: headlineStyle || 'h3',
      titleAlign: titleAlign,
      headlineFontSize: headlineFontSize,
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      textLimit: titleAlign !== 'center' ? _constant4.SIZE.WITHOUT_ICON_TEXT_LIMIT : _constant4.SIZE.CENTER_HEADLINE_TEXT_LIMIT
    }, headline);
    return headline ? headlineContainer : null;
  };

  var renderCrossSellHeadline = function renderCrossSellHeadline() {
    var _headlineParts$;

    var headlineParts = headline.split(/(?<=up to|off) /i);
    var words = (_headlineParts$ = headlineParts[2]) === null || _headlineParts$ === void 0 ? void 0 : _headlineParts$.split(' ');
    var array1 = words && (words === null || words === void 0 ? void 0 : words.slice(0, 2).join(' '));
    var array2 = words && (words === null || words === void 0 ? void 0 : words.slice(2).join(' '));
    var hotelsText = [array1];
    var destinationText = [array2];

    var headlineContainer = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexWrap: 'wrap',
        width: isMobile ? '80%' : '90%'
      }
    }, /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: "freeStyle",
      titleAlign: titleAlign,
      headlineFontSize: "16px",
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      headlineLineMarginRight: "4px"
    }, headlineParts[0]), /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: "freeStyle",
      titleAlign: titleAlign,
      headlineFontSize: "16px",
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      color: _constant4.COLOR.TAG_COLOR,
      headlineLineMarginRight: "4px"
    }, headlineParts[1]), /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: "freeStyle",
      titleAlign: titleAlign,
      headlineFontSize: "16px",
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      headlineLineMarginRight: "4px"
    }, hotelsText), /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: "freeStyle",
      titleAlign: titleAlign,
      headlineFontSize: "16px",
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      headlineLineMarginRight: "4px"
    }, destinationText), /*#__PURE__*/_react.default.createElement(ValidDateWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      color: "#D97F00",
      fontsize: "normal",
      icon: _constant4.CARD_TIMER_ICON
    }), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "tertiaryYellow",
      theme: theme,
      display: "block",
      type: "small"
    }, subHeadline))), showMoreText && !showCarouselInPopup && /*#__PURE__*/_react.default.createElement(ShowMoreTextContainer, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      ref: secondaryLinkRef,
      color: _constant4.COLOR.SEE_ALL,
      href: showMoreURL,
      queryParams: queryParams,
      hoverUnderlined: false,
      size: _constant4.SIZE.SHOW_MORE_URL_SIZE,
      target: showMoreTextTarget,
      theme: theme,
      gtmEventData: gtmParameters,
      fireGtm: createCrossSellGtmObject,
      accessible: accessible,
      callback: showMoreCallBack,
      type: showMoreType,
      idConfig: {
        parentName: 'carousel',
        widgetName: _utilities.default.replacedAll(widgetName)
      }
    }, showMoreText)));

    return headlineContainer;
  };

  var renderSubHeadline = function renderSubHeadline() {
    return !isMobile ? subHeadline && /*#__PURE__*/_react.default.createElement(SubHeadlineContainer, {
      titleAlign: titleAlign
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      ref: subHeadlineRef,
      theme: theme,
      type: subHeadlineFontSize || _constant4.SIZE.SUBHEADLINE_SIZE,
      bold: true,
      customProperties: {
        fontWeight: subHeadlineFontWeight
      },
      accessible: allowAccessibility,
      textAlign: titleAlign,
      color: subHeadlineFontColor
    }, subHeadline)) : subHeadline && /*#__PURE__*/_react.default.createElement(SubHeadlineContainer, {
      titleAlign: titleAlign
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      type: subHeadlineFontSize || _constant4.SIZE.SUBHEADLINE_SIZE_MOB,
      bold: true,
      customProperties: {
        fontWeight: subHeadlineFontWeight
      },
      textAlign: titleAlign,
      color: subHeadlineFontColor || _constant4.COLOR.SUBHEADLINE_COLOR_MOB
    }, subHeadline));
  };

  var colSpan = widgetWidth !== '' && widgetWidth || _constant4.ARR_COLUMN_SPAN[2];

  var carouselContainerKeyDownHandler = function carouselContainerKeyDownHandler() {
    setAllowAccessibility(false);

    if (headlineRef && headlineRef.current) {
      headlineRef.current.focus();
    }
  };

  var cardVisibilityHandler = function cardVisibilityHandler(index, isVisible) {
    if (!isVisible) {
      setHiddenCard(hiddenCard + 1);
    }
  };

  var timeZone = timerTimeZone && timerTimeZone.length > 0 ? timerTimeZone : _constant3.DEFAULT_TIMEZONE;
  var dateNow = (0, _cardTimer.convertDateToTimeZone)(new Date(), timeZone);
  (0, _react.useEffect)(function () {
    data.forEach(function (card) {
      if (card.timerEndDateTime) {
        var checkedTimerEndDateTime = (0, _cardTimer.checkDateTimeFormat)(card.timerEndDateTime);
        var endDate = new Date(checkedTimerEndDateTime);
        var expiredCard = 0;
        data.forEach(function () {
          if (dateNow > endDate) {
            expiredCard += 1;
          }
        });
        setHideHeader(expiredCard);
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.length]);
  var visibleCards = data.length - hiddenCard;
  var cardCountThreshold = minCardsThreeColumn ? Number(minCardsThreeColumn) : 0;

  var getCarouselContent = function getCarouselContent() {
    return /*#__PURE__*/_react.default.createElement(_Theme.default, {
      theme: theme
    }, gtmParameters && structureGtmData(), visibleCards >= cardCountThreshold && visibleCards !== 0 && /*#__PURE__*/_react.default.createElement(CarouselContainer, (0, _extends2.default)({
      ref: carouseContainerRef,
      id: widgetID,
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, carouselContainerKeyDownHandler, _constant2.KEY_CODE.ESC);
      },
      onBlur: allowAccessibility ? function (e) {
        return _utilities.default.trapFocus(e, carouseContainerRef, headlineRef);
      } : null
    }, customProperties), templateType === _constant5.TEMPLATE_TYPE.HOTELS_CROSS_SELL_CARD && headline && /*#__PURE__*/_react.default.createElement(TitleContainerCrossSell, {
      titleAlign: titleAlign,
      titleMargin: titleMargin
    }, [renderCrossSellHeadline()]), showCarouselInPopup && /*#__PURE__*/_react.default.createElement(HorizontalDivider, {
      isMobile: isMobile
    }), templateType !== _constant5.TEMPLATE_TYPE.HOTELS_CROSS_SELL_CARD && (headline || subHeadline) && hideHeader !== data.length && /*#__PURE__*/_react.default.createElement(TitleContainer, {
      titleAlign: titleAlign,
      titleMargin: titleMargin
    }, [renderHeadline(), renderSubHeadline()]), isLoading ? /*#__PURE__*/_react.default.createElement(_ShimmerCarousel.default, null) : /*#__PURE__*/_react.default.createElement(_CarouselSlider.default, {
      theme: theme,
      environment: environment,
      templateType: templateType,
      data: data,
      queryParams: queryParams,
      columnSpan: colSpan,
      cardConfig: cardConfig,
      isIE: isIE,
      viewPort: viewPort,
      enableProgressiveImageLoading: enableProgressiveImageLoading,
      gtmEventData: templateType === _constant5.TEMPLATE_TYPE.HOTELS_CROSS_SELL_CARD ? gtmParameters : eventLabelCardClick,
      lazyLoadImage: lazyLoadImage,
      fireGtm: templateType === _constant5.TEMPLATE_TYPE.HOTELS_CROSS_SELL_CARD ? fireGtm : createGtmObject,
      showFormattedPrice: showFormattedPrice,
      accessible: allowAccessibility,
      allowLocaleFormat: allowLocaleFormat,
      locale: locale,
      localeConfig: localeConfig,
      isHideFooter: isHideFooter,
      widgetID: widgetID,
      handleCardVisibility: cardVisibilityHandler,
      visibleCardCount: visibleCards,
      idConfig: {
        parentName: 'carousel',
        widgetName: _utilities.default.replacedAll(widgetName)
      },
      decimalType: decimalType,
      gaID: gaID,
      customCardHeaderHeight: customCardHeaderHeight,
      hideBorder: hideBorder,
      isHolidaysCard: isHolidaysCard,
      removeIndentation: removeIndentation,
      removeSlider: removeSlider,
      loadMoreLabel: loadMoreLabel,
      maxCards: maxCards,
      showCarouselInPopup: showCarouselInPopup
    }), showCarouselInPopup && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HorizontalDivider, {
      isMobile: isMobile
    }), /*#__PURE__*/_react.default.createElement(ButtonContainer, {
      isMobile: isMobile,
      buttonMargin: "2px"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      theme: "AIRASIA_MOVE" // color={BUTTON.COLOR}
      ,
      width: "",
      backgroundColor: "lightGreen",
      color: "black",
      borderRadius: "30px",
      handleClick: onClickButtonHandler,
      border: "1px solid black"
    }, button))), button && !showCarouselInPopup && /*#__PURE__*/_react.default.createElement(ButtonContainer, {
      buttonMargin: buttonMargin
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      href: buttonUrl,
      theme: theme,
      buttonType: _constant4.BUTTON.TYPE,
      color: _constant4.BUTTON.COLOR,
      customProperties: {
        id: "".concat(widgetName, "-carouselButton"),
        paddingLeft: viewPort === 'mobile' ? _constant4.BUTTON.PADDING_LEFT_MOBILE : _constant4.BUTTON.PADDING_LEFT,
        paddingRight: viewPort === 'mobile' ? _constant4.BUTTON.PADDING_RIGHT_MOBILE : _constant4.BUTTON.PADDING_RIGHT,
        paddingTop: _constant4.BUTTON.PADDING_TOP,
        paddingBottom: _constant4.BUTTON.PADDING_BOTTOM,
        width: viewPort === 'mobile' && _constant4.BUTTON.WIDTH
      }
    }, button))));
  };

  return showCarouselInPopup ? /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme,
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(ModalContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    width: "",
    openModal: true,
    customProperties: {
      id: 'userguide-modal'
    },
    accessible: "",
    zIndex: 13,
    modalCenter: true,
    viewPort: "",
    onClose: handleModalClose
  }, /*#__PURE__*/_react.default.createElement(Wrapper, {
    isMobile: isMobile
  }, getCarouselContent(isMobile))))) : getCarouselContent();
};

Carousel.propTypes = _Carousel.default.propTypes;
Carousel.defaultProps = _Carousel.default.DefaultProps;
var _default = Carousel;
exports.default = _default;